const responsesMap = {
  Budget: [
    { id: 'none', name: 'Solo Checklist' },
    { id: 'text', name: 'Texto' },
    { id: 'form_filler', name: 'Completar Formulario' },
    { id: 'create_document', name: 'Crear Documento' }
  ],
  Order: [
    { id: 'none', name: 'Solo Checklist' },
    { id: 'text', name: 'Texto' },
    { id: 'form_filler', name: 'Completar Formulario' },
    { id: 'budget', name: 'Presupuestación' },
    { id: 'payment', name: 'Generar Cobro' },
    { id: 'inventory_actions', name: 'Ingresar Detalle de Servicio' },
    { id: 'create_document', name: 'Crear Documento' }
  ],
  'InventoryAction::Stock': [
    { id: 'create_document', name: 'Crear Documento' },
  ],
  'InventoryAction::Pricing': [
    { id: 'none', name: 'Solo Checklist' },
    { id: 'text', name: 'Texto' },
    { id: 'edit_document', name: 'Edición de la Cotización' },
  ]
};

const defaultResponses = [
  { id: 'none', name: 'Solo Checklist' },
  { id: 'text', name: 'Texto' },
  { id: 'create_document', name: 'Crear Documento' }
];

export const customResponseDocumentTypes = [
  { id: 'InventoryAction::Pricing', name: 'Solicitud de Cotización' },
  { id: 'InventoryAction::BuyOrder', name: 'Creación de Orden de Compra' },
  { id: 'InventoryAction::Stock', name: 'Ingreso de Inventario' },
  { id: 'Invoice::Sale', name: 'Documento Tributario' },
];

export const getResponsesOptionsFor = (model: string) => responsesMap[model] || defaultResponses;
